import { Box, Button, Flex, Input, Text } from "@chakra-ui/react"
import { useState } from "react"
import SelectUsage from "./Select"
import { useForm } from "react-hook-form"
import { useSimulacaoProduto } from "../../contexts/SimulacaoProdutoContext"

const values = ["Impressão Digital", "Impressão Offset", "Impressão Serigrafia", "Impressão Sublimação"]

const valueImpressao = ["12", "13", "14", "15"]
const quantidadeImpressao = ["100", "2", "500"]
const prazoProducao = ["5", "10"]

export function Filtro() {
  const [click, setClick] = useState({
    impressao: false,
    quantidade_batidas: false,
    quantidade: false,
    codigo_cor: false,
    prazo: false,
  })

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty },
  } = useForm()

  const { getDataSimulationProducts } = useSimulacaoProduto()

  function filterSimulation(data) {
    getDataSimulationProducts(data)
  }

  const qtdX1200 = Array.from(Array(100).keys()).map((item) => item * 10)

  return (
    <Flex
      mt={4}
      gap={2}
      as="form"
      onSubmit={handleSubmit((data) => {
        filterSimulation(data)
      })}
    >
      <Box
        paddingInline={4}
        bg="#ebebeb"
        borderRadius={3}
        display="flex"
        alignItems="center"
        height="fit-content"
        position="relative"
      >
        <Text as="span" fontWeight={"bold"} color="#435E69">
          Busca:
        </Text>
        <Input
          color="#1A8AB6"
          fontWeight={"bold"}
          maxHeight="2.3rem"
          border={0}
          {...register("codigo_produto")}
          _focus={{ outline: "none" }}
        />
      </Box>
      <Box
        paddingBlock={2}
        paddingInline={4}
        bg="#ebebeb"
        borderRadius={3}
        outline={click.impressao ? "1px solid #1A8AB6" : "none"}
      >
        <SelectUsage
          label="Impressão"
          value={valueImpressao}
          width="13rem"
          setClick={() => setClick({ ...click, impressao: true })}
          onBlur={() => setClick({ ...click, impressao: false })}
          {...register("codigo_impressao")}
        />
      </Box>
      <Box
        paddingBlock={2}
        paddingInline={4}
        bg="#ebebeb"
        borderRadius={3}
        outline={click.quantidade_batidas ? "1px solid #1A8AB6" : "none"}
      >
        <SelectUsage
          label="Quantidade de Impressão"
          value={quantidadeImpressao}
          setClick={() => setClick({ ...click, quantidade_batidas: true })}
          onBlur={() => setClick({ ...click, quantidade_batidas: false })}
          {...register("quantidade_batidas")}
        />
      </Box>
      <Box
        paddingInline={4}
        bg="#ebebeb"
        borderRadius={3}
        display="flex"
        alignItems="center"
        height="fit-content"
        position="relative"
        outline={click.quantidade ? "1px solid #1A8AB6" : "none"}
      >
        <Text as="span" fontWeight={"bold"} color="#435E69">
          Quantidade:
        </Text>
        <Input
          color="#1A8AB6"
          fontWeight={"bold"}
          maxHeight="2.3rem"
          maxWidth="5rem"
          border={0}
          {...register("quantidade")}
          _focus={{ outline: "none" }}
        />
      </Box>

      <Box
        paddingBlock={2}
        paddingInline={4}
        bg="#ebebeb"
        borderRadius={3}
        outline={click.prazo ? "1px solid #1A8AB6" : "none"}
      >
        <SelectUsage
          label="Prazo de produção"
          value={prazoProducao}
          setClick={() => setClick({ ...click, prazo: true })}
          onBlur={() => setClick({ ...click, prazo: false })}
          {...register("prazo_entrega")}
        />
      </Box>
      <Button colorScheme="blue" size="sm" bg="#D06A50" borderRadius={4} type="submit">
        Simular
      </Button>
    </Flex>
  )
}
